<template>
  <router-link
    :class="[
      'BaseCapability',
      { included },
    ]"
    :to="to">
    <i
      v-if="icon"
      class="BaseCapability_icon"
      :class="icon"
      :key="icon">
    </i>
    <slot></slot>
  </router-link>
</template>

<script>
export default {
  name: 'BaseCapability',

  props: {
    included: { type: Boolean, default: false },
    to:       { type: [String, Object], default: null },
    icon:     { type: String, default: null },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/_variables';

.BaseCapability {
  display: block;
  padding: 0 4px;
  color: rgba($dark, .4);
  font-size: 12px;
  font-weight: bold;
  line-height: 36px;
  white-space: nowrap;
  text-overflow: ellipsis;
  border: 1px solid #EEEEEE;
  border-radius: $radius;
  overflow: hidden;
  &.included {
    color: $dark-blue;
    border-color: $light-blue;
    background-color: #DCEDF8;
  }
  &:hover {
    color: rgba($dark, 1);
  }
  &.included:hover {
    color: darken($dark-blue, 12%);
  }
}

.BaseCapability_icon {
  margin-right: 2px;
  font-size: 20px;
  line-height: 16px;
  vertical-align: middle;
}
</style>
